import {create} from "zustand"

export const useSitePropertiesStore = create((set) => ({
  amtlicheFlaeche:"",
  flurnummer:"",
  flurstücknummer:"",
  gemarkungName:"",
  gemarkungSchluessel:"",
  gemeindeSchluessel:"",
  baugebiet:"",
  nutzungsart:"",
  gfz:"",
  bmz :"",
  grz:"",
  erdbebenzone:"",
  untergrundklasse:"",
  windlastzone:"",
  schneelastzone:"",
  abstandflaechen:"",
  grundstuecksflaeche:"",
  //Gebaeude:"",

  updateSiteProperties: (amtlicheFlaeche, flurnummer,flurstücknummer , gemarkungName, gemarkungSchluessel,gemeindeSchluessel,
    baugebiet,nutzungsart,gfz,bmz, grz,erdbebenzone,untergrundklasse,windlastzone,schneelastzone,abstandflaechen,grundstuecksflaeche
    
  ) => 
    set({ amtlicheFlaeche, flurnummer, flurstücknummer, gemarkungName, gemarkungSchluessel,gemeindeSchluessel,
    baugebiet,nutzungsart,gfz,bmz, grz,erdbebenzone,untergrundklasse,windlastzone,schneelastzone,abstandflaechen, grundstuecksflaeche}),
    updateProperty: (key, value) => set((state) => ({ [key]: value })),
}));

export const useLandusePropertiesStore = create((set) => ({
    type: "",
    landuseType: "",

  updateLanduseProperties: (type,landuseType
  ) => 
    set({ type,landuseType }),
    updateProperty: (key, value) => set((state) => ({ [key]: value })),
}));

export const useTopographyPropertiesStore = create((set) => ({
    breitengrad: "",
    laengengrad: "",
    nhn:"",
    referenceSystem:"",

  updateTopographyProperties: (breitengrad,
    laengengrad,
    nhn,
    referenceSystem,
  ) => 
    set({ breitengrad,
    laengengrad,
    nhn,
    referenceSystem,}),
    updateProperty: (key, value) => set((state) => ({ [key]: value })),
}));


export const useBuildingPropertiesStore = create((set) => ({
        objectId:"",
        objectType:'',
        lod: "",
        muncipalityName:"",
        buildingFunction:"",
        roofShape: "",
        measuredheight:"",

        area:"",
        volume: "",
        
       

  updateBuildingProperties: (objectId,objectType,lod,muncipalityName,buildingFunction,roofShape,measuredheight, area, volume
  ) => 
    set({objectId,objectType,lod,muncipalityName,buildingFunction,roofShape,measuredheight, area, volume}),
    updateProperty: (key, value) => set((state) => ({ [key]: value })),
}));

export const useBPlanPropertiesStore = create((set) => ({
        objectId:"",
        objectType:'',
        url: "",
        label:"",
        kommune:"",
        nutzungsart: "",
        wirksamkeit:"",
        datum:"",
        status:"",
  updateBPlanProperties: (objectId, objectType, url, label, kommune, nutzungsart, wirksamkeit, datum, status
  ) => 
    set({objectId, 
        objectType,
        url,
        label, 
        kommune,
        nutzungsart,
        wirksamkeit,
        datum,
        status}),
    updateProperty: (key, value) => set((state) => ({ [key]: value })),
}));

export const useRiskareaPropertiesStore = create((set) => ({
        objectId:"",
        waterType:'',
        waterName: "",

  updateRiskareaProperties: (objectId, waterType, waterName
  ) => 
    set({objectId, waterType, waterName}),
    updateProperty: (key, value) => set((state) => ({ [key]: value })),
}));

export const useGeometryTypeStore = create((set) => ({
  geometryType: null, // Can be 'site', 'landuse', 'building', etc.
  
  setGeometryType: (type) => set({ geometryType: type }),
  
  clearGeometryType: () => set({ geometryType: null }),
}));
